import { useState, useRef } from "react";
import Highcharts from "highcharts";
import topology from "utils/maps/worldTopology.json";

export const useMapChart = (title) => {
    const chartRef = useRef(null);
    const [hasData, setHasData] = useState(true); // nuevo estado

    const [options, setOptions] = useState({
        chart: {
            map: topology,
            events: {
                load: function () {
                    chartRef.current = this;
                },
            },
        },

        title: {
            text: title,
            align: "left",
        },

        accessibility: {
            description: "Map where city locations have been defined using latitude/longitude.",
        },
        lang: {
            viewFullscreen: "Ver en pantalla completa",
            loading: "Cargando...",
            noData: "No hay datos para mostrar",
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen"],
                },
            },
        },
        mapNavigation: {
            enabled: true,
        },

        tooltip: {
            fixed: true,
            enabled: true,
            useHTML: true,
            formatter: function () {
                return `
                    <div style="min-width: 150px; white-space: normal;">
                        <b>Latitud:</b> ${this.point.lat}
                        <br />
                        <b>Longitud:</b> ${this.point.lon}
                        <br />
                        <b>Nombre</b>: ${this.point.name}
                    </div>
                `;
            },
        },

        plotOptions: {
            series: {
                turboThreshold: 0,
            },
        },

        series: [
            {
                name: "Great Britain",
                borderColor: "#A0A0A0",
                nullColor: "rgba(200, 200, 200, 0.3)",
                showInLegend: false,
            },
            {
                name: "Separators",
                type: "mapline",
                nullColor: "#707070",
                showInLegend: false,
                enableMouseTracking: false,
                accessibility: {
                    enabled: false,
                },
            },
            {
                type: "mappoint",
                name: "Puntos en el mapa",
                boostThreshold: 1,
                boostBlending: "alpha",
                dataLabels: {
                    enabled: false,
                },
                marker: {
                    radius: 6,
                    states: {
                        hover: {
                            radiusPlus: 6,
                        },
                    },
                },
                data: [],
                maxSize: "12%",
                color: Highcharts.getOptions().colors[0],
            },
        ],
        credits: { enabled: false },
    });

    const showLoading = () => chartRef.current?.showLoading();
    const hideLoading = () => chartRef.current?.hideLoading();
    const updateDataAndVisibility = (data) => {
        const chart = chartRef.current;
        if (!chart) return;

        const validData = Array.isArray(data) && data.length > 0;
        setHasData(validData);

        chart.series[0].setVisible(validData, false);
        chart.series[1].setVisible(validData, false);
        chart.series[2].setData(data, false);
        chart.redraw();
    };

    const onChartReady = (chartInstance) => {
        chartRef.current = chartInstance;
    };

    return {
        options,
        setOptions,
        showLoading,
        hideLoading,
        onChartReady,
        updateDataAndVisibility,
        hasData,
    };
    
};
